import { jsx as _jsx } from "react/jsx-runtime";
import { GDPR_PREFERENCES_COOKIE } from '@wkda/gdprlib';
import { createContext, useCallback, useContext, useMemo, useState, } from 'react';
import { categories } from './constants';
import { createSubmitHandlers } from './createSubmitHandlers';
import { isEverythingSelected } from './helpers';
const defaultSelectionState = {
    [categories.ESSENTIAL]: true,
    [categories.ANALYTICAL]: false,
    [categories.MARKETING]: false,
};
const defaultState = {
    state: defaultSelectionState,
    toggleSelection: () => () => { },
    submit: () => Promise.resolve(),
    submitAll: function () {
        throw new Error('Function not implemented.');
    },
    isEverythingSelected: false,
};
const BannerStateContext = createContext(defaultState);
function useGDPRBannerState(initialState = defaultSelectionState) {
    const [bannerState, setBannerState] = useState(initialState);
    function toggleSelection(key) {
        return function $toggleSelection() {
            return setBannerState((prevState) => key === categories.ESSENTIAL
                ? prevState
                : {
                    ...prevState,
                    [key]: !prevState[key],
                });
        };
    }
    function selectAll() {
        return Object.keys(bannerState).reduce((acc, key) => ({
            ...acc,
            [key]: true,
        }), {});
    }
    return {
        state: bannerState,
        toggleSelection,
        setBannerState,
        selectAll,
        isEverythingSelected: isEverythingSelected(bannerState),
    };
}
export function GDPRBannerStateProvider({ children, isProd, APIService, cookieService, onSubmit, }) {
    const [shouldDisplayBanner, setShouldDisplayBanner] = useState(true);
    function getCurrentSelection() {
        const { categories: preferences } = cookieService.get(GDPR_PREFERENCES_COOKIE) || {};
        return Object.keys(defaultSelectionState).reduce((acc, key) => {
            const pref = Array.isArray(preferences) ? preferences : [];
            return {
                ...acc,
                [key]: pref.includes(key) || key === categories.ESSENTIAL,
            };
        }, {});
    }
    const { state, toggleSelection, selectAll, setBannerState, isEverythingSelected,
    //@ts-expect-error TODO: fix
     } = useGDPRBannerState(getCurrentSelection());
    const { submit } = createSubmitHandlers({
        APIService,
        cookieService,
        isProd,
        onSubmit,
    });
    const submitAll = useCallback(async () => {
        const selectionState = selectAll();
        //@ts-expect-error TODO: fix
        setBannerState(selectionState);
        await submit(selectionState);
        // This will allow user to see the selection update
        setTimeout(() => {
            return setShouldDisplayBanner(false);
        }, 100);
    }, [selectAll, setBannerState, submit]);
    const submitSelected = useCallback(() => {
        //@ts-expect-error TODO: fix
        return submit(state);
    }, [state, submit]);
    const value = useMemo(() => {
        return {
            state,
            toggleSelection,
            submit: submitSelected,
            submitAll,
            isEverythingSelected,
        };
    }, [isEverythingSelected, state, submitAll, submitSelected, toggleSelection]);
    return (
    //@ts-expect-error TODO: fix
    _jsx(BannerStateContext.Provider, { value: value, children: shouldDisplayBanner ? children : null }));
}
export function useGDPRBannerContext() {
    const context = useContext(BannerStateContext);
    return context;
}
